import { useEffect, useState } from "react";
import { mobileMediaQuery } from "../constants/mobileBreakpoint";

/**
 * True when viewport uses the compact shell (phones + tablets, max-width 1023px).
 * Single source for shell gating; matches `mobileMediaQuery` in `constants/mobileBreakpoint`.
 */
function canUseMatchMedia(): boolean {
  return (
    typeof window !== "undefined" && typeof window.matchMedia === "function"
  );
}

export function useIsMobile(): boolean {
  const [isMobile, setIsMobile] = useState(() => {
    if (!canUseMatchMedia()) {
      return false;
    }
    return window.matchMedia(mobileMediaQuery).matches;
  });

  useEffect(() => {
    if (!canUseMatchMedia()) {
      return;
    }
    const mq = window.matchMedia(mobileMediaQuery);
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  return isMobile;
}
